export interface TableQuickFiltersSectionProps {
  children?: React.ReactNode;
}

export function TableQuickFiltersSection(props: TableQuickFiltersSectionProps) {
  const { children } = props;

  return <div>{children}</div>;
}
